import { useSelector } from "react-redux";
import { useState } from "react";
import { selectDateFilter, selectReportType } from "src/redux/selectors/experiences/leadsAndReports";
import { convertDatesToTimezone, dateKey } from "src/services/experiences/leadsAndReports/dateUtils";
import { ChartView, ReportRequest } from "src/types/experiences/leadsAndReports";
import { DEFAULT_REPORT_TYPE } from "../constants";

export const useTableState = (storyboardId: string, forceDefaultReportType = false) => {
  const selectedReportType = useSelector(selectReportType);
  const reportType = forceDefaultReportType ? DEFAULT_REPORT_TYPE : selectedReportType;
  const dateFilter = useSelector(selectDateFilter);
  const [page, setPage] = useState(0);
  const [chart, setChart] = useState<ChartView>("table_view");

  const request: ReportRequest = {
    storyboard: storyboardId,
    reportType,
    ...convertDatesToTimezone(dateFilter ?? undefined),
  };

  return {
    reportType,
    dateFilter,
    key: dateKey(dateFilter ?? undefined),
    request,
    page,
    setPage,
    chart,
    setChart,
    enabled: Boolean(dateFilter),
  };
};
